export default __webpack_public_path__ + "static/photoJoin-c9ec4baa0e69fd5488bf8951edb4f908.svg";